var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChecks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M12.5 15.9294C15.6066 15.9294 18.125 13.411 18.125 10.3044C18.125 7.19784 15.6066 4.67944 12.5 4.67944C9.3934 4.67944 6.875 7.19784 6.875 10.3044C6.875 13.411 9.3934 15.9294 12.5 15.9294Z",
    fill: "#36B2A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.3044H9.37501C7.63055 20.3044 6.75832 20.3044 6.04857 20.5197C4.45057 21.0045 3.20005 22.255 2.7153 23.853C2.5 24.5628 2.5 25.435 2.5 27.1794M20 23.4294L22.5 25.9294L27.5 20.9294M18.125 10.3044C18.125 13.411 15.6066 15.9294 12.5 15.9294C9.3934 15.9294 6.875 13.411 6.875 10.3044C6.875 7.19784 9.3934 4.67944 12.5 4.67944C15.6066 4.67944 18.125 7.19784 18.125 10.3044Z",
    stroke: "#36B2A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecks);
export default __webpack_public_path__ + "static/media/ic-checks.57b86ec227e5c1831a7e43f1d662c6ed.svg";
export { ForwardRef as ReactComponent };